export default "The folder were all description for each person is saved";